import React from 'react';
import logo from '../Assets/Group 114.png';
import ball1 from '../Assets/Ellipse 16.png';
import ball2 from '../Assets/Ellipse 11.png';
import ball3 from '../Assets/Ellipse 24.png';
import ball4 from '../Assets/Ellipse 14.png';

export default function NavBar() {
    return (
        <div className="NavBar">
            <nav>
                <img src={logo} alt="/" />
                <ul>
                    <li>Home</li>
                    <li>Services</li>
                    <li>Pricing</li>
                    <li>About Us</li>
                    <li id="Last">Start a Company</li>
                </ul>
            </nav>

            <div className="SearchBar">
                <div className="ball1">
                    <img src={ball1} alt="" />
                </div>
                <div className="ball2">
                    <img src={ball2} alt="" />
                </div>
                <div className="search">
                <input type="search" placeholder="🔍  Search a Term | Topic" />
                </div>
            </div>

            <div className="Onlyballs">
                <div className="ball3">
                    <img src={ball3} alt="" />
                </div>
                <div className="ball4">
                    <img src={ball4} alt="" />
                </div>
            </div>
        </div>
    );
}
